import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { GridColDef } from "@mui/x-data-grid";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import { UserProfile } from "../../../../store/auth/types";
import { DocumentType, RequestStatus } from "../../../Enum";

interface AdministrationColumnsProps {
  profile: UserProfile;
  binusianUnderLevel: string[];
}

export function AdministrationColumns({
  profile,
  binusianUnderLevel,
}: AdministrationColumnsProps): GridColDef[] {
  return [
    {
      field: "action",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderHeader: () => <b>Action</b>,
      renderCell: (params): any => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {((params.row.requestStatus === RequestStatus.Draft &&
            params.row.binusianID === profile.BinusianId) ||
            (params.row.requestStatus === RequestStatus.Pending &&
              params.row.binusianID === profile.BinusianId) ||
            (params.row.requestStatus === RequestStatus.Pending &&
              binusianUnderLevel.includes(params.row.binusianID))) && (
            <Link
              to={`/edit/${params.row.requestID}`}
              style={{ width: "30px" }}
            >
              <EditOutlinedIcon className="pencilAction" />
            </Link>
          )}

          {(params.row.requestStatus === RequestStatus.SendBack ||
            params.row.requestStatus === RequestStatus.RequestReceive ||
            params.row.requestStatus === RequestStatus.RequestRevise) && (
            <Link
              to={`/approvalcl/${params.row.requestID}`}
              style={{ width: "30px" }}
            >
              <EditOutlinedIcon className="pencilAction" />
            </Link>
          )}

          {params.row.requestStatus === RequestStatus.NeedResponse &&
            params.row.documentType === DocumentType.Hardcopy && (
              <Link
                to={`/clsendsk/${params.row.requestID}`}
                style={{ width: "30px" }}
              >
                <EditOutlinedIcon className="pencilAction" />
              </Link>
            )}

          {(params.row.requestStatus === RequestStatus.AwaitingConfirmation ||
            params.row.requestStatus === RequestStatus.Finished ||
            params.row.requestStatus === RequestStatus.FinishedRevised) && (
            <Link
              to={`/approvallr/${params.row.requestID}`}
              style={{ width: "30px" }}
            >
              <EditOutlinedIcon className="pencilAction" />
            </Link>
          )}

          <Link to={`/view/${params.row.requestID}`} style={{ width: "30px" }}>
            <SearchOutlinedIcon className="black" />
          </Link>
        </div>
      ),
    },
    {
      field: "requestStatus",
      width: 150,
      renderHeader: () => <b>Request Status</b>,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {((params.row.requestStatus === RequestStatus.Draft &&
            params.row.binusianID === profile.BinusianId) ||
            (params.row.requestStatus === RequestStatus.Pending &&
              params.row.binusianID === profile.BinusianId) ||
            (params.row.requestStatus === RequestStatus.Pending &&
              binusianUnderLevel.includes(params.row.binusianID))) && (
            <Link
              style={{ color: "#6C2882" }}
              to={`/edit/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          )}

          {(params.row.requestStatus === RequestStatus.SendBack ||
            params.row.requestStatus === RequestStatus.RequestReceive ||
            params.row.requestStatus === RequestStatus.RequestRevise) && (
            <Link
              style={{ color: "#6C2882" }}
              to={`/approvalcl/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          )}

          {params.row.requestStatus === RequestStatus.NeedResponse &&
            params.row.documentType === DocumentType.Hardcopy && (
              <Link
                style={{ color: "#6C2882" }}
                to={`/clsendsk/${params.row.requestID}`}
              >
                {params.row.requestStatus}
              </Link>
            )}

          {(params.row.requestStatus === RequestStatus.AwaitingConfirmation ||
            params.row.requestStatus === RequestStatus.Finished ||
            params.row.requestStatus === RequestStatus.FinishedRevised) && (
            <Link
              style={{ color: "#6C2882" }}
              to={`/approvallr/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          )}

          {params.row.requestStatus === RequestStatus.FinishedCanceled && (
            <Link
              style={{ color: "#6C2882" }}
              to={`/view/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          )}

          {(params.row.requestStatus === RequestStatus.Canceled ||
            params.row.requestStatus === RequestStatus.Rejected ||
            (params.row.requestStatus === RequestStatus.Pending &&
              !binusianUnderLevel.includes(params.row.binusianID) &&
              params.row.binusianID !== profile.BinusianId)) && (
            <Link
              style={{ color: "#6C2882" }}
              to={`/view/${params.row.requestID}`}
            >
              {params.row.requestStatus}
            </Link>
          )}
        </div>
      ),
    },
    {
      field: "requestNumber",
      width: 220,
      renderHeader: () => <b>Request No.</b>,
    },
    {
      field: "requestDate",
      width: 180,
      renderHeader: () => <b>Request Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.requestDate}</Moment>
        </div>
      ),
    },
    {
      field: "binusianName",
      width: 150,
      renderHeader: () => <b>Name</b>,
    },
    {
      field: "businessUnit",
      width: 170,
      renderHeader: () => <b>Business Unit</b>,
      renderCell: (params) =>
        params.row.businessUnit != params.row.department ? (
          <div>
            {params.row.businessUnit} - {params.row.department}
          </div>
        ) : (
          <div>{params.row.businessUnit}</div>
        ),
    },
    { field: "noCRR", width: 170, renderHeader: () => <b>CRR No.</b> },
    {
      field: "counterpart",
      width: 250,
      renderHeader: () => <b>Counterpart</b>,
    },
    {
      field: "requestType",
      width: 150,
      renderHeader: () => <b>Request Type</b>,
    },
    {
      field: "documentType",
      width: 150,
      renderHeader: () => <b>Document Type</b>,
    },
    {
      field: "poaDate",
      width: 180,
      renderHeader: () => <b>POA Date</b>,
      renderCell: (params) => (
        <div>
          <Moment format="DD MMMM YYYY">{params.row.poaDate}</Moment>
        </div>
      ),
    },
    {
      field: "noPOA",
      width: 250,
      renderHeader: () => <b>POA No.</b>,
      renderCell: (params) => (
        <div>
          {params.row.noPOA}
          <br />
          {params.row.noSubstitution}
        </div>
      ),
    },
  ];
}
